export default "__VITE_ASSET__689c526f__"